import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import CategoryIcon from "@/components/site/CategoryIcon";

export default function CategoryCard({ c, i = 0, detailed = false, testId }) {
  return (
    <Link to={`/categories/${c.slug}`} data-testid={testId} style={{ animationDelay: `${i * 35}ms` }}
      className={`card card-hover group relative rise flex ${detailed ? "gap-5 p-7" : "flex-col p-5"} hover:border-[#B9D3CF]`}>
      <span className={`icon-tile ${detailed ? "h-12 w-12" : "h-11 w-11"} shrink-0 group-hover:bg-[#0F766E] group-hover:border-[#0F766E] group-hover:text-white`}>
        <CategoryIcon name={c.icon} className={detailed ? "h-6 w-6" : "h-5 w-5"} />
      </span>
      <div className={detailed ? "" : "mt-5"}>
        {detailed ? <h2 className="text-lg font-semibold leading-snug">{c.name}</h2> : <h3 className="font-display text-[15px] font-semibold text-[#17243A] leading-snug">{c.name}</h3>}
        {detailed && <p className="mt-1.5 text-sm text-[#526174] leading-relaxed">{c.description}</p>}
        <p className="mt-2 text-xs font-medium text-[#64728A]" data-testid={`${testId}-count`}>{c.count} {c.count === 1 ? "tool" : "tools"} listed</p>
      </div>
      <ArrowUpRight className="absolute top-5 right-5 h-4 w-4 text-[#8A96A8] opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-[opacity,transform] duration-300" aria-hidden="true" />
    </Link>
  );
}
